import { render, staticRenderFns } from "./viewKcpCorrect.vue?vue&type=template&id=0574a034&scoped=true"
import script from "./viewKcpCorrect.vue?vue&type=script&lang=js"
export * from "./viewKcpCorrect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0574a034",
  null
  
)

export default component.exports